import MDTypography from "@/components/atoms/MDTypography";
import { renderWhatsAppText } from "@/helpers/chat-whatsapp-text";

type WhatsAppMessageTextProps = {
  text: string;
  color: "white" | "dark";
};

export default function WhatsAppMessageText({ text, color }: WhatsAppMessageTextProps) {
  return (
    <MDTypography
      variant="button"
      color={color}
      sx={{ whiteSpace: "pre-wrap", display: "block" }}
    >
      {renderWhatsAppText(text)}
    </MDTypography>
  );
}
